export enum ItemStatusType {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DISABLED = "DISABLED",
  PENDING = "PENDING",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED"
}
